export default {
  finish: 'Finished today',
  loading: 'Loading',
  submitTask: 'Submit',
  TempSaveTask: 'Temporary save',
  play: 'Play',
  stop: 'Stop',
  pause: 'Pause',
  zoomout: 'Zoom out',
  zoomin: 'Zoom in',
  cut: 'Split',
  add: 'Add',
  regionPlay: 'Play selected',
  regionDelete: 'Delete selected',
  valid: 'Valid',
  noValid: 'Invalid',
  editor: 'Notes',
  rejectTask: 'Reject',
  acceptTask: 'Pass',
  // reviseAndAccept: 'Submit and pass',
  reviseTask: 'Revise',
  success: 'Success',
  warning: 'Warning',
  error: 'Failure',
  errorMessage: 'Please check and make sure that all the annotations are finished',
  choise: 'Please select',
  enter: 'Please enter',
  allWrong: 'All failed',
  grouptask: 'Group task',
  ques: 'Are you sure you want to modify and pass the task?',
  caveat: 'Warning',
  confirm: 'Comfirm',
  cancel: 'Cancellation',
  errorMessage2: 'Please fill in the reason for the rejection',
  openReport: 'Appeal',
  errorMessage3: 'Please doing the annotation as required',
  reason: 'Reason for appeal',
  dataDesc: 'Data description',
  skip: 'Skip',
  wavTemp0: 'Playing speed up',
  wavTemp1: 'Playing slowdown',
  wavTemp2: 'Add timestamp',
  wavTemp3: 'Delete the left timestamp',
  wavTemp4: 'Delete the right time stamp',
  wavTemp5: 'Delete all timestamps',
  wavTemp6: 'Play selected segment',
  wavTemp7: 'Global question',
  wavTemp8: 'required',
  wavTemp9: 'Phonetic transcription',
  wavTemp11:	'Word count',
  wavTemp12:	'task',
  wavTemp15:	'undone',
  wavTemp18:	'all',
  wavTemp22:	'current',
  wavTemp25:	'Effective',
  wavTemp26:	'Invalid',
  wavTemp27:	'Assist above',
  wavTemp28:	'Assist below',
  wavTemp29:	'Please enter the transcription content',
  collectBtn01: 'verification',
  rightData: 'Data',
  rightBeizhu: 'Remarks',
  delall: 'Are you sure to delete all marks?'
}



// WEBPACK FOOTER //
// ./src/lang/en/public/taskPublic.js